import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";

export const AWARD_LI1 = "AWARD_LI1";
export const AWARD_LI2 = "AWARD_LI2";
export const AWARD_LI3 = "AWARD_LI3";
export const AWARD_LI4 = "AWARD_LI4";
export const AWARD_LI5 = "AWARD_LI5";
export const AWARD_LI6 = "AWARD_LI6";
export const AWARD_LI7 = "AWARD_LI7";
export const AWARD_LI8 = "AWARD_LI8";
export const AWARD_LI9 = "AWARD_LI9";
export const AWARD_LI10 = "AWARD_LI10";
export const AWARD_LI11 = "AWARD_LI11";
export const AWARD_LI12 = "AWARD_LI12";
export const AWARD_LI13 = "AWARD_LI13";
export const AWARD_LI14 = "AWARD_LI14";
export const AWARD_LI15 = "AWARD_LI15";
export const AWARD_LI16 = "AWARD_LI16";
export const AWARD_LI17 = "AWARD_LI17";
export const AWARD_LI18 = "AWARD_LI18";
export const AWARD_LI19 = "AWARD_LI19";
export const AWARD_LI20 = "AWARD_LI20";
export const AWARD_LI21 = "AWARD_LI21";
export const AWARD_LI22 = "AWARD_LI22";
export const AWARD_LI23 = "AWARD_LI23";
export const AWARD_LI24 = "AWARD_LI24";
export const AWARD_LI25 = "AWARD_LI25";
export const AWARD_LI26 = "AWARD_LI26";
export const AWARD_LI27 = "AWARD_LI27";
export const AWARD_LI28 = "AWARD_LI28";
export const AWARD_LI29 = "AWARD_LI29";
export const AWARD_LI30 = "AWARD_LI30";
export const AWARD_LI31 = "AWARD_LI31";
export const AWARD_LI32 = "AWARD_LI32";
export const AWARD_LI33 = "AWARD_LI33";
export const AWARD_LI34 = "AWARD_LI34";
export const AWARD_LI35 = "AWARD_LI35";
export const AWARD_LI36 = "AWARD_LI36";
export const AWARD_LI37 = "AWARD_LI37";
export const AWARD_LI38 = "AWARD_LI38";
export const AWARD_LI39 = "AWARD_LI39";
export const AWARD_LI40 = "AWARD_LI40";
export const AWARD_LI41 = "AWARD_LI41";
export const AWARD_LI42 = "AWARD_LI42";
export const AWARD_LI43 = "AWARD_LI43";
export const AWARD_LI44 = "AWARD_LI44";
export const AWARD_LI45 = "AWARD_LI45";
export const AWARD_LI46 = "AWARD_LI46";
export const AWARD_LI47 = "AWARD_LI47";
export const AWARD_LI48 = "AWARD_LI48";
export const AWARD_LI49 = "AWARD_LI49";
export const AWARD_LI50 = "AWARD_LI50";
export const AWARD_LI51 = "AWARD_LI51";
export const AWARD_LI52 = "AWARD_LI52";
export const AWARD_LI53 = "AWARD_LI53";
export const AWARD_LI54 = "AWARD_LI54";
export const AWARD_LI55 = "AWARD_LI55";
export const AWARD_LI56 = "AWARD_LI56";
export const AWARD_LI57 = "AWARD_LI57";
export const AWARD_LI58 = "AWARD_LI58";
export const AWARD_LI59 = "AWARD_LI59";
export const AWARD_LI60 = "AWARD_LI60";
export const AWARD_LI61 = "AWARD_LI61";
export const AWARD_LI62 = "AWARD_LI62";
export const AWARD_LI63 = "AWARD_LI63";
export const AWARD_LI64 = "AWARD_LI64";
export const AWARD_LI65 = "AWARD_LI65";
export const AWARD_LI66 = "AWARD_LI66";
export const AWARD_LI67 = "AWARD_LI67";
export const AWARD_LI68 = "AWARD_LI68";
export const AWARD_LI69 = "AWARD_LI69";
export const AWARD_LI70 = "AWARD_LI70";
export const AWARD_LI71 = "AWARD_LI71";
export const AWARD_LI72 = "AWARD_LI72";
export const AWARD_LI73 = "AWARD_LI73";
export const AWARD_LI74 = "AWARD_LI74";
export const AWARD_LI75 = "AWARD_LI75";
export const AWARD_LI76 = "AWARD_LI76";
export const AWARD_LI77 = "AWARD_LI77";
export const AWARD_LI78 = "AWARD_LI78";
export const AWARD_LI79 = "AWARD_LI79";
export const AWARD_LI80 = "AWARD_LI80";
export const AWARD_LI81 = "AWARD_LI81";
export const AWARD_LI82 = "AWARD_LI82";
export const AWARD_LI83 = "AWARD_LI83";
export const AWARD_LI84 = "AWARD_LI84";
export const AWARD_LI85 = "AWARD_LI85";
export const AWARD_LI86 = "AWARD_LI86";
export const AWARD_LI87 = "AWARD_LI87";
export const AWARD_LI88 = "AWARD_LI88";
export const AWARD_LI89 = "AWARD_LI89";
export const AWARD_LI90 = "AWARD_LI90";
export const AWARD_LI91 = "AWARD_LI91";
export const AWARD_LI92 = "AWARD_LI92";
export const AWARD_LI93 = "AWARD_LI93";
export const AWARD_LI94 = "AWARD_LI94";
export const AWARD_LI95 = "AWARD_LI95";
export const AWARD_LI96 = "AWARD_LI96";
export const AWARD_LI97 = "AWARD_LI97";
export const AWARD_LI98 = "AWARD_LI98";
export const AWARD_LI99 = "AWARD_LI99";
export const AWARD_LI100 = "AWARD_LI100";
export const AWARD_LI101 = "AWARD_LI101";
export const AWARD_LI102 = "AWARD_LI102";
export const AWARD_LI103 = "AWARD_LI103";
export const AWARD_LI104 = "AWARD_LI104";
export const AWARD_LI105 = "AWARD_LI105";
export const AWARD_LI106 = "AWARD_LI106";
export const AWARD_LI107 = "AWARD_LI107";
export const AWARD_LI108 = "AWARD_LI108";
export const AWARD_LI109 = "AWARD_LI109";
export const AWARD_LI110 = "AWARD_LI110";
export const AWARD_LI111 = "AWARD_LI111";
export const AWARD_LI112 = "AWARD_LI112";
export const AWARD_LI113 = "AWARD_LI113";
export const AWARD_LI114 = "AWARD_LI114";
export const AWARD_LI115 = "AWARD_LI115";
export const AWARD_LI116 = "AWARD_LI116";
export const AWARD_LI117 = "AWARD_LI117";
export const AWARD_LI118 = "AWARD_LI118";
export const AWARD_LI119 = "AWARD_LI119";
export const AWARD_LI120 = "AWARD_LI120";
export const AWARD_LI121 = "AWARD_LI121";
export const AWARD_LI122 = "AWARD_LI122";
export const AWARD_LI123 = "AWARD_LI123";
export const AWARD_LI124 = "AWARD_LI124";
export const AWARD_LI125 = "AWARD_LI125";
export const AWARD_LI126 = "AWARD_LI126";
export const AWARD_LI127 = "AWARD_LI127";
export const AWARD_LI128 = "AWARD_LI128";
export const AWARD_LI129 = "AWARD_LI129";
export const AWARD_LI130 = "AWARD_LI130";
export const AWARD_LI131 = "AWARD_LI131";
export const AWARD_LI132 = "AWARD_LI132";
export const AWARD_LI133 = "AWARD_LI133";
export const AWARD_LI134 = "AWARD_LI134";
export const AWARD_LI135 = "AWARD_LI135";
export const AWARD_LI136 = "AWARD_LI136";
export const AWARD_LI137 = "AWARD_LI137";
export const AWARD_LI138 = "AWARD_LI138";
export const AWARD_LI139 = "AWARD_LI139";
export const AWARD_LI140 = "AWARD_LI140";
export const AWARD_LI141 = "AWARD_LI141";
export const AWARD_LI142 = "AWARD_LI142";
export const AWARD_LI143 = "AWARD_LI143";
export const AWARD_LI144 = "AWARD_LI144";
export const AWARD_LI145 = "AWARD_LI145";
export const AWARD_LI146 = "AWARD_LI146";
export const AWARD_LI147 = "AWARD_LI147";
export const AWARD_LI148 = "AWARD_LI148";
export const AWARD_LI149 = "AWARD_LI149";
export const AWARD_LI150 = "AWARD_LI150";
export const AWARD_LI151 = "AWARD_LI151";
export const AWARD_LI152 = "AWARD_LI152";
export const AWARD_LI153 = "AWARD_LI153";
export const AWARD_LI154 = "AWARD_LI154";
export const AWARD_LI155 = "AWARD_LI155";
export const AWARD_LI156 = "AWARD_LI156";
export const AWARD_LI157 = "AWARD_LI157";
export const AWARD_LI158 = "AWARD_LI158";
export const AWARD_LI159 = "AWARD_LI159";
export const AWARD_LI160 = "AWARD_LI160";
export const AWARD_LI161 = "AWARD_LI161";
export const AWARD_LI162 = "AWARD_LI162";
export const AWARD_LI163 = "AWARD_LI163";
export const AWARD_LI164 = "AWARD_LI164";
export const AWARD_LI165 = "AWARD_LI165";
export const AWARD_LI166 = "AWARD_LI166";
export const AWARD_LI167 = "AWARD_LI167";
export const AWARD_LI168 = "AWARD_LI168";
export const AWARD_LI169 = "AWARD_LI169";
export const AWARD_LI170 = "AWARD_LI170";
export const AWARD_LI171 = "AWARD_LI171";
export const AWARD_LI172 = "AWARD_LI172";
export const AWARD_LI173 = "AWARD_LI173";
export const AWARD_LI174 = "AWARD_LI174";
export const AWARD_LI175 = "AWARD_LI175";
export const AWARD_LI176 = "AWARD_LI176";
export const AWARD_LI177 = "AWARD_LI177";
export const AWARD_LI178 = "AWARD_LI178";
export const AWARD_LI179 = "AWARD_LI179";
export const AWARD_LI180 = "AWARD_LI180";
export const AWARD_LI181 = "AWARD_LI181";
export const AWARD_LI182 = "AWARD_LI182";
export const AWARD_LI183 = "AWARD_LI183";
export const AWARD_LI184 = "AWARD_LI184";
export const AWARD_LI185 = "AWARD_LI185";
export const AWARD_LI186 = "AWARD_LI186";
export const AWARD_LI187 = "AWARD_LI187";
export const AWARD_LI188 = "AWARD_LI188";
export const AWARD_LI189 = "AWARD_LI189";
export const AWARD_LI190 = "AWARD_LI190";
export const AWARD_LI191 = "AWARD_LI191";
export const AWARD_LI192 = "AWARD_LI192";
export const AWARD_LI193 = "AWARD_LI193";
export const AWARD_LI194 = "AWARD_LI194";
export const AWARD_LI195 = "AWARD_LI195";
export const AWARD_LI196 = "AWARD_LI196";
export const AWARD_LI197 = "AWARD_LI197";
export const AWARD_LI198 = "AWARD_LI198";
export const AWARD_LI199 = "AWARD_LI199";
export const AWARD_LI200 = "AWARD_LI200";
export const AWARD_LI201 = "AWARD_LI201";
export const AWARD_LI202 = "AWARD_LI202";
export const AWARD_LI203 = "AWARD_LI203";
export const AWARD_LI204 = "AWARD_LI204";
export const AWARD_LI205 = "AWARD_LI205";
export const AWARD_LI206 = "AWARD_LI206";
export const AWARD_LI207 = "AWARD_LI207";
export const AWARD_LI208 = "AWARD_LI208";
export const AWARD_LI209 = "AWARD_LI209";
export const AWARD_LI210 = "AWARD_LI210";
export const AWARD_LI211 = "AWARD_LI211";
export const AWARD_LI212 = "AWARD_LI212";
export const AWARD_LI213 = "AWARD_LI213";
export const AWARD_LI214 = "AWARD_LI214";
export const AWARD_LI215 = "AWARD_LI215";
export const AWARD_LI216 = "AWARD_LI216";
export const AWARD_LI217 = "AWARD_LI217";
export const AWARD_LI218 = "AWARD_LI218";
export const AWARD_LI219 = "AWARD_LI219";
export const AWARD_LI220 = "AWARD_LI220";
export const AWARD_LI221 = "AWARD_LI221";
export const AWARD_LI222 = "AWARD_LI222";
export const AWARD_LI223 = "AWARD_LI223";
export const AWARD_LI224 = "AWARD_LI224";
export const AWARD_LI225 = "AWARD_LI225";
export const AWARD_LI226 = "AWARD_LI226";
export const AWARD_LI227 = "AWARD_LI227";
export const AWARD_LI228 = "AWARD_LI228";
export const AWARD_LI229 = "AWARD_LI229";
export const AWARD_LI230 = "AWARD_LI230";
export const AWARD_LI231 = "AWARD_LI231";
export const AWARD_LI232 = "AWARD_LI232";
export const AWARD_LI233 = "AWARD_LI233";
export const AWARD_LI234 = "AWARD_LI234";
export const AWARD_LI235 = "AWARD_LI235";
export const AWARD_LI236 = "AWARD_LI236";
export const AWARD_LI237 = "AWARD_LI237";
export const AWARD_LI238 = "AWARD_LI238";

export const translations = {
  en: {
    [HEADING1]: "Awards",

    [AWARD_LI1]:
      "Union Transport Minister’s Trophy for the lowest Accident Record 1998-2001",
    [AWARD_LI2]: "Parisara Award by Govt. of Karnataka. 2001",
    [AWARD_LI3]: "IRTE Prince Michael International Road safety Award 2002",
    [AWARD_LI4]:
      "Safety Award by Chartered Institute of Logistics & Transport 2001-2002",
    [AWARD_LI5]: "Petroleum Conservation Research Association Award 2001-02",
    [AWARD_LI6]: "Petroleum Conservation Research Association Award 2002-03",
    [AWARD_LI7]: "Golden Peacock Environment management Award 2003",
    [AWARD_LI8]: "Golden Peacock Eco Innovation Award 2004",
    [AWARD_LI9]:
      "Received Prestigious Runner-up Award from PCRA for the best improvement in HSD KMPL 2001-02",
    [AWARD_LI10]:
      "KSRTC adjudged Winner for the best improvement in HSD KMPL 2002-03",
    [AWARD_LI11]:
      "KSRTC also adjudged Winner for the best improvement in HSD KMPL 2003-04",
    [AWARD_LI12]:
      "OSHMS 18001, ISO 14001 & 9001 certification for conformance towards occupational health & safety management system standard. 2006",
    [AWARD_LI13]:
      "Safety innovation of 2006 for safety & quality by Institute of Eng. New Delhi. 2006",
    [AWARD_LI14]:
      "Indian Express EMPI Innovation Award at New Delhi By Hon’ble President of India Abdul Kalam 2007-08",
    [AWARD_LI15]:
      "Award for Excellence by Ministry Of Urban Development Govt. of India for implementing Electronic Driving Test System 2008",
    [AWARD_LI16]:
      "National e-Governance Award for Exemplary Usage of ICT among PSUs by Ministry ",
    [AWARD_LI17]: "Personnel & Administrative Reforms, Govt. of India 2009",
    [AWARD_LI18]:
      "Rajiv Gandhi National Quality Award Best Large Scale Service Industry in the Country 2009",
    [AWARD_LI19]:
      "Award for Excellence by Ministry Of Urban Development Govt. of India for implementing Automated Electronic Driving Test System 2009",
    [AWARD_LI20]:
      "India Pride Gold Award Infrastructure and Transportation 2010",

    [AWARD_LI21]:
      "Award for Excellence by Ministry Of Urban Development Govt. of India for Best Clean Development Mechanism 2010",
    [AWARD_LI22]:
      "Chief Minister’s Ratna Award for Best Performing State PSUs 2010",
    [AWARD_LI23]: "Golden Peacock Innovative Product/Service Award 2010",
    [AWARD_LI24]: "Golden Peacock Eco-Innovation Award 2010",
    [AWARD_LI25]: "PRCI- Chanakya Corporate Leadership Award 2010",
    [AWARD_LI26]: "Apollo-CV Best Public Bus Operator of the year 2010",
    [AWARD_LI27]: "Deccan Chronicle Green Warrior Award 2010",
    [AWARD_LI28]: "m-Billionth South Asia Award- 2010",
    [AWARD_LI29]: "SKOCH The World is Open Award 2010",
    [AWARD_LI30]:
      "Earth Care Award for Excellence in Climate Change Mitigation & Adaption 2010",
    [AWARD_LI31]: "IBM Great Mind Challenger for Business Award 2010",
    [AWARD_LI32]: "Manthan South Asia Award 2010",
    [AWARD_LI33]: "IIMM Corporate Excellence Award 2010",
    [AWARD_LI34]: "Global HR Excellence Award 2010",
    [AWARD_LI35]: "Best Employer Award for Innovation in Recruitment 2010",
    [AWARD_LI36]: "Edward de Bone’s Award for Innovations in HR 2010",
    [AWARD_LI37]: "RASBIC Award Best Use of Technology for Recruiting 2010",
    [AWARD_LI38]:
      "PRCI- Corporate Collateral Best Public Service Campaign Award- 2010",
    [AWARD_LI39]:
      "PRCI- Corporate Collateral Best Corporate Brochure Award 2010",
    [AWARD_LI40]: "e-India Award Certificate 2010",
    [AWARD_LI41]:
      "Low-floor buses for JnNURM cities, KSRTC was the first organization in India to submit proposals and get Appreciation Letter from ministry of Urban Development 2010",
    [AWARD_LI42]:
      "IITK - Distinguished Alumnus Award for outstanding managerial skills in application of e-technology for modernization of urban and rural transport system 2011",
    [AWARD_LI43]: "UITP- 1st PX2Regional Political Commitment Award 2011",
    [AWARD_LI44]:
      "National 1st FIEO – Telecom Technology Award by Ministry of Commerce and Industry, Govt. of India 2011",
    [AWARD_LI45]:
      "PRCI- Corporate Collateral Award Best Coffee Table Book -English- Gold award 2011",
    [AWARD_LI46]: "PRCI- Corporate Collateral Award In-house magazine 2011",
    [AWARD_LI47]:
      "PRCI- Corporate Collateral Award in Corporate Advertisement 2011",
    [AWARD_LI48]: "Asia’s Best Employer Award 2011",
    [AWARD_LI49]:
      "Best Practices Documentation & Award Program, six initiatives have been shortlisted by Karnataka State Government 2011",
    [AWARD_LI50]:
      "Award for Excellence by Ministry Of Urban Development Govt. of India for Best Practices in Urban Transport for Inclusive Development for Providing Sustainable Mobility for small towns 2011",
    [AWARD_LI51]:
      "ASRTU Award by Ministry of Road Transport & Highways Govt. of India. 2011",
    [AWARD_LI52]: "Volvo Sustainable Mobility Award- 2011",
    [AWARD_LI53]: "D.M.A.I Synergy Award 2012",
    [AWARD_LI54]: "Digiratti Award for Effective social media management 2012",
    [AWARD_LI55]: "National Telecom Award 2012",
    [AWARD_LI56]: "Skoch Digital Inclusion Gold Award 2012",
    [AWARD_LI57]: "IIMM bestowed Best CEO of the year Award 2012",
    [AWARD_LI58]:
      "ASRTU Profit Making STU Award by Ministry of Road Transport & Highways, Govt. of India 2012",
    [AWARD_LI59]: "Golden Peacock Innovative Product/Service Award 2012",
    [AWARD_LI60]: "Apollo-CV Best Public Fleet Operator of the Year Award 2012",
    [AWARD_LI61]: "PRCI Corporate Collateral Awards Documentary Film 2012",
    [AWARD_LI62]: "PRCI Chankya National Achiever Award 2012",
    [AWARD_LI63]: "PRCI Corporate Collateral Awards Online News Letter 2012",
    [AWARD_LI64]:
      "PRCI Corporate Collateral Awards Kannada Coffee Table Book 2012",
    [AWARD_LI65]:
      "PRCI Corporate Collateral Awards Corporate Advertisement 2012",
    [AWARD_LI66]: "PRCI Corporate Collateral Awards Documentary Film 2012",
    [AWARD_LI67]: "PRCI Corporate Collateral Awards Television Commercial 2012",
    [AWARD_LI68]:
      "PRCI Corporate Collateral Awards Television Documentary 2012",
    [AWARD_LI69]: "IIMM SCM Best Innovation Award 2013",
    [AWARD_LI70]:
      "International Public Transport Award (UITP) Innovation Award 2013",
    [AWARD_LI71]:
      "Apollo CV Award for Public sector bus fleet operator of the year 2013",
    [AWARD_LI72]:
      "PRCI Corporate Collateral Silver Award Corporate Advertisement 2013",
    [AWARD_LI73]:
      "PRCI Corporate Collateral Silver Award Documentary Film 2013",
    [AWARD_LI74]:
      "PRCI Corporate Collateral Silver Award Television Commercial 2014",
    [AWARD_LI75]:
      "PRCI Corporate Collateral Bronze Award Television Documentary 2014",
    [AWARD_LI76]: "KSRTC awarded as Bangalore’s Hot Brand Award 2014",
    [AWARD_LI77]:
      "KSRTC won India prestigious India Says Yes award in the category of AC BUS JOURNEYS WITH KSRTC 2014",
    [AWARD_LI78]:
      "Golden Peacock Innovative Product/Service Award for ITS Mysore 2014",
    [AWARD_LI79]:
      "Global Brand Excellence PR Professional of the year award 2014",
    [AWARD_LI80]: "Global Brand Excellence Award for Fly Bus initiative 2014",
    [AWARD_LI81]:
      "SKOTCH Best Top 100 initiatives in the country for FLYBUS Initiative 2014",
    [AWARD_LI82]:
      "Award of Excellence by Ministry of Urban Development, Govt. of India for Mysore Intelligent Transport System Project 2014",
    [AWARD_LI83]:
      "PRCI Corporate Collateral Silver Award In-house Magazine 2015",
    [AWARD_LI84]:
      "PRCI Corporate Collateral Platinum Award Television Commercial 2015",
    [AWARD_LI85]:
      "PRCI Corporate Collateral Silver Award Print media advertisement 2015",
    [AWARD_LI86]:
      "CMAK Karnataka’s Best Practice Award for Automated Driving Test System 2015",

    [AWARD_LI87]:
      "ASRTU Transport Innovation Award for Staff Duty Rota System and Leave Management Kiosk System 2015",
    [AWARD_LI88]:
      "ASRTU Transport Innovation Award for Environment Management 2015",
    [AWARD_LI89]:
      "Greentech HR Technology Excellence Award for Staff Duty Rota System & Leave Management Kiosk System 2015",
    [AWARD_LI90]:
      "UITP Transport Award for Staff Duty Rota System at Milan Italy 2015",
    [AWARD_LI91]: "Bangalore Hot 50 Brand Award for KSRTC 2015",
    [AWARD_LI92]:
      "Supply Chain Management Award for Karnataka State Road Transport 2015",
    [AWARD_LI93]:
      "ASRTU National Transport Excellence Award for IT initiatives 2015",
    [AWARD_LI94]:
      "ASRTU Productivity Award for Minimum Operational Cost Mysore Urban Service 2015",
    [AWARD_LI95]:
      "India Bus Awards for ‘Staff Duty Rota System’ under the category Excellence in Employee Welfare 2015",
    [AWARD_LI96]:
      "Intelligent Transport System of Mysore City under the category Excellence in Bus Transport Service in India. India Bus Award 2015",
    [AWARD_LI97]: "India’s Hot Brand Award 2015",
    [AWARD_LI98]:
      "SKOTCH Best Top 100 initiatives in the country for FLYBUS Initiative 2015",
    [AWARD_LI99]:
      "SKOTCH Best Top 100 initiatives in the country for Organised city bus services at small and medium towns and cities- 2015",
    [AWARD_LI100]:
      "SKOTCH Best Top 100 initiatives in the country for Staff Duty Rota System 2015",
    [AWARD_LI101]:
      "SKOTCH Smart Governance Award Organised Public Transport city bus for small and medium towns and cities 2015",
    [AWARD_LI102]:
      "2nd Annual PSU Award for Intelligent Transport System at Mysore City 2015",
    [AWARD_LI103]:
      "Award of Excellence by Ministry of Urban Development, Govt. of India for the 6th time in a row, for the initiative of providing organized city bus services for small and medium towns and cities. 2015",
    [AWARD_LI104]: "PRCI Corporate Collateral Award In-house Magazine 2016",
    [AWARD_LI105]:
      "PRCI Corporate Collateral Award-Corporate Advertisement 2016",
    [AWARD_LI106]:
      "PRCI Corporate Collateral Award-Documentary Film on bio bus 2016",
    [AWARD_LI107]: "PRCI Corporate Collateral Award- broucher on bio bus 2016",
    [AWARD_LI108]:
      "PRCI Corporate Collateral Award-Branding of Airavat Diamond Class Bus 2016",
    [AWARD_LI109]:
      "Chankya Award Best PR and Corporate Communication Person of the year Award 2016",
    [AWARD_LI110]:
      "Global Communication Association Award for Excellence in Communication in Government Sector 2016",
    [AWARD_LI111]: "NIB National Award-2016 for In-house Magazine 2016",
    [AWARD_LI112]: "Karnataka’s Best Practice Award (CMAK) 2016",
    [AWARD_LI113]: "Digital Empowerment Award for AWATAR 2016",
    [AWARD_LI114]:
      "ASRTU Annual Special Awards for Environment Management Prakruthi 2016",
    [AWARD_LI115]:
      "India Pride Award ‘Best State PSU of the Country’ in the category of Infrastructure and Transportation 2016",
    [AWARD_LI116]:
      "World Resource Institute ConnectKaro Award for Organised city bus services at tier two and three cities and towns 2016",
    [AWARD_LI117]: "Greentech HR Award for Innovation in Recruitment 2016",
    [AWARD_LI118]:
      "2nd Smart Cities India Award for Smart Urban Mobility ITS Mysore 2016",
    [AWARD_LI119]: "Economics Times Supply Chain & Logistics Award-2016 2016",
    [AWARD_LI120]: "FKCCI Karnataka Tourism Award-2016 2016",
    [AWARD_LI121]: "Greentech Safety Award-2016 2016",
    [AWARD_LI122]: "India Bus Awards-2016 2016",
    [AWARD_LI123]: "Elets Smart City Award-2016 2016",
    [AWARD_LI124]:
      "SKOCH Order of Merit -2016 Prakruthi (Green Squad) and Bio-Bus (Go-Green-Think Green) 2016",
    [AWARD_LI125]:
      "SKOCH Order of Merit -2016 AWATAR Any Where Any Time Advance Reservation System 2016",
    [AWARD_LI126]:
      "SKOCH Order of Merit -2016 Intelligent transport systems with mobile App 2016",
    [AWARD_LI127]:
      "SKOCH Order of Merit -2016 Vehicle Tracking, Monitoring System and Passenger Information System - VTMS & PIS Project 2016",

    [AWARD_LI128]:
      "CMO ASIA Smart City Award-2016 Singapore – Smart Urban Development Initiative 2016",
    [AWARD_LI129]:
      "CMO ASIA Smart City Award-2016 Singapore- Smart Transport Initiative 2016",
    [AWARD_LI130]:
      "CMO ASIA Smart City Award-2016 Singapore- Best Innovation Initiative 2016",
    [AWARD_LI131]: "World Arogya Gold Award-2016 2016",
    [AWARD_LI132]: "Asia Pacific HR award for Ideas and Innovations in HR 2016",
    [AWARD_LI133]:
      "National Awards for Excellence in Corporate Communication for Its’ My Bus 2016",
    [AWARD_LI134]:
      "SKOCH Smart Governance Platinum Award -2016 Prakruthi (Green Squad) and Bio-Bus (Go-Green-Think Green) 2016",
    [AWARD_LI135]:
      "SKOCH Smart Governance Platinum Award -2016 AWATAR Any Where Any Time Advance Reservation System 2016",
    [AWARD_LI136]:
      "SKOCH Smart Governance Platinum Award -2016 Intelligent transport systems with mobile App 2016",
    [AWARD_LI137]:
      "10th Express Logistics & Supply Chain Leadership Awards-Customer Intimacy @ Service Excellence Company of the Year 2016",
    [AWARD_LI138]: "Drivers of Digital award – Best Website -Travel 2016",
    [AWARD_LI139]: "Greentech Environment Award 2016",
    [AWARD_LI140]: "Global Marketing Excellence Award 2016",
    [AWARD_LI141]:
      "SKOCH Order of Merit Intelligent Transport System (ITS) with Mobile App 2016",
    [AWARD_LI142]: "SKOCH Order of Merit Its My Bus 2016",
    [AWARD_LI143]:
      "SKOCH Order of Merit Branding Initiatives for Service Excellence 2016",

    [AWARD_LI144]:
      "SKOCH Order of Merit Initiatives For Healthy Workplace 2016",
    [AWARD_LI145]:
      "SKOCH Order of Merit Initiatives for Improved Road Safety 2016",
    [AWARD_LI146]:
      "SKOCH Order of Merit AWATAR ( Any Time Any Where Advance Reservation System) 2016",
    [AWARD_LI148]:
      "SKOCH Order of Merit Initiatives City Bus Service for Medium and Small Cities 2016",
    [AWARD_LI149]:
      "SKOCH Order of Merit Automated Electronic Driving Test System 2016",
    [AWARD_LI150]: "SKOCH Order of Merit Fly Bus 2016",
    [AWARD_LI151]:
      "SKOCH Order of Merit Staff Duty Rota & Leave Management Kiosk System 2016",
    [AWARD_LI152]:
      "SKOCH Order of Merit Smart technology in Transport Operations 2016",
    [AWARD_LI153]:
      "SKOCH Order of Merit Cleanliness initiatives at Work place 2016",
    [AWARD_LI154]:
      "SKOCH Order of Merit Vehicle Tracking, Monitoring System and Passenger Information System - VTMS & PIS Project. 2016",
    [AWARD_LI155]:
      "SKOCH Order of Merit WAPPA - Workplace Alcohol Prevention Programme and Activity 2016",
    [AWARD_LI156]: "SKOCH Order of Merit Prakruthi & Bio Bus 2016",
    [AWARD_LI157]: "World Leadership Award- ITS 2016",
    [AWARD_LI158]: "BW Business World Award 2016",
    [AWARD_LI159]: "Influential Business Award 2016",
    [AWARD_LI160]:
      "The India PR& Corporate Communications Award-Prakruthi 2016",
    [AWARD_LI161]:
      "The India PR& Corporate Communications Award-It’s My Bus 2016",
    [AWARD_LI162]: "SKOCH Mobility Award WAPPA 2016",
    [AWARD_LI163]: "SKOCH Mobility Award ITS with Mobile App 2016",
    [AWARD_LI164]: "SKOCH Mobility Award City Bus services 2016",
    [AWARD_LI165]: "SKOCH Mobility Award Prakruthi & Bio Bus 2016",
    [AWARD_LI166]: "SKOCH Mobility Award Healthy Workplace 2016",
    [AWARD_LI167]: "National e-Governance Gold Award 2017",
    [AWARD_LI168]: "Limca Book of Records 2017",
    [AWARD_LI169]: "Global Clean India Award 2017",
    [AWARD_LI170]: "Global Safety India Award 2017",

    [AWARD_LI171]: "Manthan Award 2017",
    [AWARD_LI172]: "CMAK Award 2017",
    [AWARD_LI173]: "PSU Leadership Award 2017",
    [AWARD_LI174]: "PSU Award- AWATAR 2017",
    [AWARD_LI175]: "EKDKN Exceed HR Awards 2017",
    [AWARD_LI176]: "EKDKN Exceed Environment Awards 2017",
    [AWARD_LI177]: "BBC Employer Award 2017",
    [AWARD_LI178]: "PRCI Corporate Leadership Award- Chanakya 2017",
    [AWARD_LI179]: "NIB Awards-In house magazine 2017",
    [AWARD_LI180]: "NIB Awards- It’s My Bus movie 2017",
    [AWARD_LI181]: "NIB Awards- Broucher 2017",
    [AWARD_LI182]: "Indian Brand Convention Awards 2017",
    [AWARD_LI183]: "Indian Brand Convention Awards 2017",
    [AWARD_LI184]: "Indian Brand Convention Awards 2017",
    [AWARD_LI185]: "Indian Brand Convention Awards 2017",
    [AWARD_LI186]: "BPCL Innovation Award for Technology in e-Governance 2017",
    [AWARD_LI187]: "PRCI Awards- It’s My Bus Campaign 2017",
    [AWARD_LI189]: "PRCI Awards- Annual Report 2017",
    [AWARD_LI190]: "PRCI Awards- In-house magazine 2017",
    [AWARD_LI191]: "PRCI Awards-Corporate Advertisement- Print 2017",
    [AWARD_LI192]: "PRCI Awards- movie 2017",
    [AWARD_LI193]: "ASRTU Award-Profit Making STU 2016-17 2017",
    [AWARD_LI194]: "India Pride Award 2017",
    [AWARD_LI195]: "Connect Karo Awards 2017",
    [AWARD_LI196]: "UITP award 2017",
    [AWARD_LI197]: "HUDCO Award 2017",
    [AWARD_LI198]: "Social Media for Empowerment Award 2017",
    [AWARD_LI199]: "M3 Marketing Awards 2017",
    [AWARD_LI200]: "Greentech HR Award 2017",
    [AWARD_LI201]: "India Bus Awards-Environment 2017",
    [AWARD_LI202]: "India Bus Awards- Best Transport Service ITS 2017",
    [AWARD_LI203]: "Project Managers Institute Award 2017",
    [AWARD_LI204]: "World- wide Achievers Business Awards 2017",
    [AWARD_LI205]: "Prawas Excellence Award 2017",
    [AWARD_LI206]: "Prawas Excellence Award 2017",
    [AWARD_LI207]: "Prawas Excellence Award 2017",
    [AWARD_LI208]: "ASRTU National Transport Excellence Award 2017",
    [AWARD_LI209]: "SKOTCH Order of Merit- Prakruthi 2017",
    [AWARD_LI210]: "SKOTCH Order of Merit- VTMS 2017",
    [AWARD_LI211]: "SKOTCH Order of Merit- ITS 2017",
    [AWARD_LI212]: "SKOTCH Order of Merit- City Bus Services 2017",
    [AWARD_LI213]: "IRU Awards-2017 2017",
    [AWARD_LI214]: "Business World Smart City Award 2017",
    [AWARD_LI215]: "CMAK Best Practice Award 2018",
    [AWARD_LI216]: "PRCI Chanakya Award Corporate Idea of The Year 2018",
    [AWARD_LI217]: "Sarige Sampda- PRCI Corporate Collateral Award 2018",
    [AWARD_LI218]: "Radio jingle- PRCI Corporate Collateral Award 2018",
    [AWARD_LI219]: "India Pride Award 2018",
    [AWARD_LI220]: "Smart Governance award- VTMS 2018",
    [AWARD_LI221]: "Smart Governance award- AWATAR 2018",
    [AWARD_LI222]: "Smart Governance award- Healthy Workplace Initiatives 2018",
    [AWARD_LI223]:
      "Smart Governance award- Smart Technology in Operations 2018",
    [AWARD_LI224]: "India Bus Award 2018",
    [AWARD_LI225]: "State e-Governance Award 2018",
    [AWARD_LI226]: "Award of Excellence –MoUD 2018",
    [AWARD_LI227]: "SKOCH AWARD-SIlver 2019",
    [AWARD_LI228]: "SKOCH Award-Copper 2019",
    [AWARD_LI229]: "SKOCH Mobility Award-Silver 2019",
    [AWARD_LI230]: "PRCI- In-house magazine- Silver 2019",
    [AWARD_LI231]: "PRCI_ awareness video-Silver 2019",
    [AWARD_LI232]: "PRCI- Corporate video-Slver 2019",
    [AWARD_LI233]: "CMAK Best Practice Award 2019",
    [AWARD_LI234]: "Profit Making STU –ASRTU Productivity Award 2019",
    [AWARD_LI235]: "Minimum Operational Cost Mysore City -ASRTU 2019",
    [AWARD_LI236]: "HUDCO Best Practices Award 2019",
    [AWARD_LI237]: "IOL Times Now Best Passenger Transport-Inter City 2019",
    [AWARD_LI238]: "IOL Times Now Women Achiever Award 2019",
  },
  kn: {
    [HEADING1]: "ಪ್ರಶಸ್ತಿಗಳು",
    [AWARD_LI1]:
      "1998-2001 ರ ಅತ್ಯಂತ ಕಡಿಮೆ ಅಪಘಾತ ದಾಖಲೆಗಾಗಿ ಕೇಂದ್ರ ಸಾರಿಗೆ ಸಚಿವರ ಟ್ರೋಫಿ",
    [AWARD_LI2]: "ಕರ್ನಾಟಕ ಸರ್ಕಾರದಿಂದ ಪರಿಸರ ಪ್ರಶಸ್ತಿ. 2001",
    [AWARD_LI3]:
      "IRTE ಪ್ರಿನ್ಸ್ ಮೈಕೆಲ್ ಇಂಟರ್ನ್ಯಾಷನಲ್ ರಸ್ತೆ ಸುರಕ್ಷತೆ ಪ್ರಶಸ್ತಿ 2002",
    [AWARD_LI4]:
      "ಚಾರ್ಟರ್ಡ್ ಇನ್‌ಸ್ಟಿಟ್ಯೂಟ್ ಆಫ್ ಲಾಜಿಸ್ಟಿಕ್ಸ್ & ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ 2001-2002 ರ ಸುರಕ್ಷತಾ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI5]: "ಪೆಟ್ರೋಲಿಯಂ ಕನ್ಸರ್ವೇಶನ್ ರಿಸರ್ಚ್ ಅಸೋಸಿಯೇಷನ್ ಪ್ರಶಸ್ತಿ 2001-02",
    [AWARD_LI6]: "ಪೆಟ್ರೋಲಿಯಂ ಕನ್ಸರ್ವೇಶನ್ ರಿಸರ್ಚ್ ಅಸೋಸಿಯೇಷನ್ ಪ್ರಶಸ್ತಿ 2002-03",
    [AWARD_LI7]: "ಗೋಲ್ಡನ್ ಪೀಕಾಕ್ ಎನ್ವಿರಾನ್ಮೆಂಟ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ ಅವಾರ್ಡ್ 2003",
    [AWARD_LI8]: "ಗೋಲ್ಡನ್ ಪೀಕಾಕ್ ಇಕೋ ಇನ್ನೋವೇಶನ್ ಅವಾರ್ಡ್ 2004",
    [AWARD_LI9]:
      "HSD KMPL 2001-02 ರಲ್ಲಿ ಉತ್ತಮ ಸುಧಾರಣೆಗಾಗಿ PCRA ನಿಂದ ಪ್ರತಿಷ್ಠಿತ ರನ್ನರ್-ಅಪ್ ಪ್ರಶಸ್ತಿಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
    [AWARD_LI10]:
      "KSRTC HSD KMPL 2002-03 ರಲ್ಲಿ ಉತ್ತಮ ಸುಧಾರಣೆಗಾಗಿ ವಿಜೇತರನ್ನು ಗುರುತಿಸಿದೆ",
    [AWARD_LI11]:
      "KSRTC HSD KMPL 2003-04 ರಲ್ಲಿ ಉತ್ತಮ ಸುಧಾರಣೆಗಾಗಿ ವಿಜೇತರನ್ನು ಗುರುತಿಸಿದೆ",
    [AWARD_LI12]:
      "OSHMS 18001, ISO 14001 & 9001 ಪ್ರಮಾಣೀಕರಣವು ಔದ್ಯೋಗಿಕ ಆರೋಗ್ಯ ಮತ್ತು ಸುರಕ್ಷತಾ ನಿರ್ವಹಣಾ ವ್ಯವಸ್ಥೆಯ ಮಾನದಂಡಕ್ಕೆ ಅನುಗುಣವಾಗಿರುತ್ತದೆ. 2006",
    [AWARD_LI13]:
      "ಇನ್‌ಸ್ಟಿಟ್ಯೂಟ್ ಆಫ್ ಇಂಜಿನಿಯರ್‌ನಿಂದ ಸುರಕ್ಷತೆ ಮತ್ತು ಗುಣಮಟ್ಟಕ್ಕಾಗಿ 2006 ರ ಸುರಕ್ಷತಾ ನಾವೀನ್ಯತೆ. ನವ ದೆಹಲಿ. 2006",
    [AWARD_LI14]:
      "2007-08 ರ ಗೌರವಾನ್ವಿತ ರಾಷ್ಟ್ರಪತಿ ಅಬ್ದುಲ್ ಕಲಾಂ ಅವರಿಂದ ನವದೆಹಲಿಯಲ್ಲಿ ಇಂಡಿಯನ್ ಎಕ್ಸ್‌ಪ್ರೆಸ್ EMPI ಇನ್ನೋವೇಶನ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI15]:
      "ಭಾರತ ಸರ್ಕಾರದಿಂದ ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯದಿಂದ ಶ್ರೇಷ್ಠತೆಗಾಗಿ ಪ್ರಶಸ್ತಿ ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಡ್ರೈವಿಂಗ್ ಟೆಸ್ಟ್ ಸಿಸ್ಟಮ್ 2008 ",
    [AWARD_LI16]:
      "ಸಚಿವಾಲಯದಿಂದ PSU ಗಳಲ್ಲಿ ICT ಯ ಅನುಕರಣೀಯ ಬಳಕೆಗಾಗಿ ರಾಷ್ಟ್ರೀಯ ಇ-ಆಡಳಿತ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI17]: "ಸಿಬ್ಬಂದಿ ಮತ್ತು ಆಡಳಿತ ಸುಧಾರಣೆಗಳು, ಭಾರತ ಸರ್ಕಾರ. 2009",
    [AWARD_LI18]:
      "ರಾಜೀವ್ ಗಾಂಧಿ ರಾಷ್ಟ್ರೀಯ ಗುಣಮಟ್ಟದ ಪ್ರಶಸ್ತಿ 2009 ರ ದೇಶದ ಅತ್ಯುತ್ತಮ ದೊಡ್ಡ ಪ್ರಮಾಣದ ಸೇವಾ ಉದ್ಯಮ",
    [AWARD_LI19]:
      "ಭಾರತ ಸರ್ಕಾರದಿಂದ ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯದಿಂದ ಶ್ರೇಷ್ಠತೆಗಾಗಿ ಪ್ರಶಸ್ತಿ ಸ್ವಯಂಚಾಲಿತ ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಡ್ರೈವಿಂಗ್ ಟೆಸ್ಟ್ ಸಿಸ್ಟಮ್ 2009",
    [AWARD_LI20]: "ಇಂಡಿಯಾ ಪ್ರೈಡ್ ಗೋಲ್ಡ್ ಅವಾರ್ಡ್ ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಸಾರಿಗೆ 2010",

    [AWARD_LI21]:
      "ಭಾರತ ಸರ್ಕಾರದಿಂದ ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯದಿಂದ ಶ್ರೇಷ್ಠತೆಗಾಗಿ 2010 ರ ಪ್ರಶಸ್ತಿ  ಅತ್ಯುತ್ತಮ ಕ್ಲೀನ್ ಡೆವಲಪ್‌ಮೆಂಟ್ ಮೆಕ್ಯಾನಿಸಂಗಾಗಿ",
    [AWARD_LI22]:
      "2010 ರ ಅತ್ಯುತ್ತಮ ಕಾರ್ಯನಿರ್ವಹಣೆಯ ರಾಜ್ಯ PSUಗಳಿಗಾಗಿ ಮುಖ್ಯಮಂತ್ರಿಗಳ ರತ್ನ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI23]: "ಗೋಲ್ಡನ್ ಪೀಕಾಕ್ ನವೀನ ಉತ್ಪನ್ನ/ಸೇವಾ ಪ್ರಶಸ್ತಿ 2010",
    [AWARD_LI24]: "ಗೋಲ್ಡನ್ ಪೀಕಾಕ್ ಇಕೋ-ಇನ್ನೋವೇಶನ್ ಅವಾರ್ಡ್ 2010",
    [AWARD_LI25]: "PRCI- ಚಾಣಕ್ಯ ಕಾರ್ಪೊರೇಟ್ ನಾಯಕತ್ವ ಪ್ರಶಸ್ತಿ 2010",
    [AWARD_LI26]: "ಅಪೊಲೊ-ಸಿವಿ 2010 ರ ವರ್ಷದ ಅತ್ಯುತ್ತಮ ಸಾರ್ವಜನಿಕ ಬಸ್ ನಿರ್ವಾಹಕರು",
    [AWARD_LI27]: "ಡೆಕ್ಕನ್ ಕ್ರಾನಿಕಲ್ ಗ್ರೀನ್ ವಾರಿಯರ್ ಪ್ರಶಸ್ತಿ 2010",
    [AWARD_LI28]: "m-ಬಿಲಿಯನ್ ದಕ್ಷಿಣ ಏಷ್ಯಾ ಪ್ರಶಸ್ತಿ- 2010",
    [AWARD_LI29]: "ಸ್ಕೋಚ್ ದಿ ವರ್ಲ್ಡ್ ಈಸ್ ಓಪನ್ ಅವಾರ್ಡ್ 2010",
    [AWARD_LI30]:
      "ಹವಾಮಾನ ಬದಲಾವಣೆ ತಗ್ಗಿಸುವಿಕೆ ಮತ್ತು ಅಡಾಪ್ಷನ್ 2010 ರಲ್ಲಿ ಶ್ರೇಷ್ಠತೆಗಾಗಿ ಅರ್ಥ್ ಕೇರ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI31]: "BM ಗ್ರೇಟ್ ಮೈಂಡ್ ಚಾಲೆಂಜರ್ ಫಾರ್ ಬಿಸಿನೆಸ್ ಅವಾರ್ಡ್ 2010",
    [AWARD_LI32]: "ಮಂಥನ್ ಸೌತ್ ಏಷ್ಯಾ ಪ್ರಶಸ್ತಿ 2010",
    [AWARD_LI33]: "IIMM ಕಾರ್ಪೊರೇಟ್ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2010",
    [AWARD_LI34]: "ಗ್ಲೋಬಲ್ HR ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2010",
    [AWARD_LI35]:
      "ನೇಮಕಾತಿ 2010 ರಲ್ಲಿ ನಾವೀನ್ಯತೆಗಾಗಿ ಅತ್ಯುತ್ತಮ ಉದ್ಯೋಗದಾತ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI36]: "HR 2010 ರಲ್ಲಿ ಇನ್ನೋವೇಶನ್ಸ್ಗಾಗಿ ಎಡ್ವರ್ಡ್ ಡಿ ಬೋನ್ಸ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI37]:
      "RASBIC ಪ್ರಶಸ್ತಿ 2010 ರ ನೇಮಕಾತಿಗಾಗಿ ತಂತ್ರಜ್ಞಾನದ ಅತ್ಯುತ್ತಮ ಬಳಕೆ",
    [AWARD_LI38]:
      "PRCI- ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅತ್ಯುತ್ತಮ ಸಾರ್ವಜನಿಕ ಸೇವಾ ಅಭಿಯಾನ ಪ್ರಶಸ್ತಿ- 2010",
    [AWARD_LI39]:
      "PRCI- ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಬೆಸ್ಟ್ ಕಾರ್ಪೊರೇಟ್ ಬ್ರೋಷರ್ ಪ್ರಶಸ್ತಿ 2010",
    [AWARD_LI40]: "ಇ-ಇಂಡಿಯಾ ಪ್ರಶಸ್ತಿ ಪ್ರಮಾಣಪತ್ರ 2010",
    [AWARD_LI41]:
      "JnNURM ನಗರಗಳಿಗೆ ಲೋ-ಫ್ಲೋರ್ ಬಸ್‌ಗಳು, KSRTC ಪ್ರಸ್ತಾವನೆಗಳನ್ನು ಸಲ್ಲಿಸಲು ಮತ್ತು ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯ 2010 ರಿಂದ ಮೆಚ್ಚುಗೆ ಪತ್ರವನ್ನು ಪಡೆದ ಭಾರತದ ಮೊದಲ ಸಂಸ್ಥೆಯಾಗಿದೆ.",
    [AWARD_LI42]:
      "IITK - ನಗರ ಮತ್ತು ಗ್ರಾಮೀಣ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಯ ಆಧುನೀಕರಣಕ್ಕಾಗಿ ಇ-ತಂತ್ರಜ್ಞಾನದ ಅನ್ವಯದಲ್ಲಿ ಅತ್ಯುತ್ತಮ ನಿರ್ವಹಣಾ ಕೌಶಲ್ಯಗಳಿಗಾಗಿ ಡಿಸ್ಟಿಂಗ್ವಿಶ್ಡ್ ಅಲುಮ್ನಸ್ ಪ್ರಶಸ್ತಿ 2011",
    [AWARD_LI43]: "UITP- 1ನೇ PX2ಪ್ರಾದೇಶಿಕ ರಾಜಕೀಯ ಬದ್ಧತೆ ಪ್ರಶಸ್ತಿ 2011",
    [AWARD_LI44]:
      "ರಾಷ್ಟ್ರೀಯ 1 ನೇ FIEO - ವಾಣಿಜ್ಯ ಮತ್ತು ಕೈಗಾರಿಕಾ ಸಚಿವಾಲಯ, ಸರ್ಕಾರದಿಂದ ಟೆಲಿಕಾಂ ತಂತ್ರಜ್ಞಾನ ಪ್ರಶಸ್ತಿ. ಭಾರತದ 2011",
    [AWARD_LI45]:
      "PRCI- ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ ಅತ್ಯುತ್ತಮ ಕಾಫಿ ಟೇಬಲ್ ಪುಸ್ತಕ -ಇಂಗ್ಲಿಷ್- ಗೋಲ್ಡ್ ಪ್ರಶಸ್ತಿ 2011",
    [AWARD_LI46]: "PRCI- ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ ಇನ್-ಹೌಸ್ ಮ್ಯಾಗಜೀನ್ 2011",
    [AWARD_LI47]:
      "PRCI- ಕಾರ್ಪೊರೇಟ್ ಜಾಹೀರಾತು 2011 ರಲ್ಲಿ ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI48]: "ಏಷ್ಯಾದ ಅತ್ಯುತ್ತಮ ಉದ್ಯೋಗದಾತ ಪ್ರಶಸ್ತಿ 2011",
    [AWARD_LI49]:
      "ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸಗಳ ದಾಖಲೀಕರಣ ಮತ್ತು ಪ್ರಶಸ್ತಿ ಕಾರ್ಯಕ್ರಮ, ಆರು ಉಪಕ್ರಮಗಳನ್ನು ಕರ್ನಾಟಕ ರಾಜ್ಯ ಸರ್ಕಾರ 2011 ರ ಶಾರ್ಟ್‌ಲಿಸ್ಟ್ ಮಾಡಿದೆ",
    [AWARD_LI50]:
      "ನಗರ ಸಾರಿಗೆಯಲ್ಲಿನ ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸಗಳಿಗಾಗಿ 2011 ಭಾರತ ಸರ್ಕಾರದಿಂದ ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯದಿಂದ ಶ್ರೇಷ್ಠತೆಗಾಗಿ ಪ್ರಶಸ್ತಿ ಸಣ್ಣ ಪಟ್ಟಣಗಳಿಗೆ ಸುಸ್ಥಿರ ಚಲನಶೀಲತೆಯನ್ನು ಒದಗಿಸುವುದಕ್ಕಾಗಿ ಅಂತರ್ಗತ ಅಭಿವೃದ್ಧಿಗಾಗಿ. ",
    [AWARD_LI51]:
      "ಭಾರತ ರಸ್ತೆ ಸಾರಿಗೆ ಮತ್ತು ಹೆದ್ದಾರಿಗಳ ಸಚಿವಾಲಯದಿಂದ ASRTU ಪ್ರಶಸ್ತಿ 2011",
    [AWARD_LI52]: "ವೋಲ್ವೋ ಸಸ್ಟೈನಬಲ್ ಮೊಬಿಲಿಟಿ ಅವಾರ್ಡ್- 2011",
    [AWARD_LI53]: "D.M.A.I ಸಿನರ್ಜಿ ಪ್ರಶಸ್ತಿ 2012",
    [AWARD_LI54]:
      "2012 ರ ಪರಿಣಾಮಕಾರಿ ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ನಿರ್ವಹಣೆಗಾಗಿ ಡಿಜಿರಟ್ಟಿ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI55]: "ರಾಷ್ಟ್ರೀಯ ಟೆಲಿಕಾಂ ಪ್ರಶಸ್ತಿ 2012",
    [AWARD_LI56]: "ಸ್ಕೋಚ್ ಡಿಜಿಟಲ್ ಸೇರ್ಪಡೆ ಚಿನ್ನದ ಪ್ರಶಸ್ತಿ 2012",
    [AWARD_LI57]: "IIMM 2012 ರ ವರ್ಷದ ಅತ್ಯುತ್ತಮ CEO ಪ್ರಶಸ್ತಿಯನ್ನು ನೀಡಿದೆ",
    [AWARD_LI58]:
      "ರಸ್ತೆ ಸಾರಿಗೆ ಮತ್ತು ಹೆದ್ದಾರಿಗಳ ಸಚಿವಾಲಯ, ಸರ್ಕಾರದಿಂದ ASRTU ಲಾಭ ಗಳಿಸುವ STU ಪ್ರಶಸ್ತಿ ಭಾರತದ 2012",
    [AWARD_LI59]: "ಗೋಲ್ಡನ್ ಪೀಕಾಕ್ ನವೀನ ಉತ್ಪನ್ನ/ಸೇವಾ ಪ್ರಶಸ್ತಿ 2012",
    [AWARD_LI60]:
      "ಅಪೊಲೊ-CV ವರ್ಷದ ಅತ್ಯುತ್ತಮ ಸಾರ್ವಜನಿಕ ಫ್ಲೀಟ್ ಆಪರೇಟರ್ ಪ್ರಶಸ್ತಿ 2012",
    [AWARD_LI61]: "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ಸಾಕ್ಷ್ಯಚಿತ್ರ 2012",
    [AWARD_LI62]: "PRCI ಚಾಂಕ್ಯ ರಾಷ್ಟ್ರೀಯ ಸಾಧಕ ಪ್ರಶಸ್ತಿ 2012",
    [AWARD_LI63]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ಆನ್‌ಲೈನ್ ಸುದ್ದಿ ಪತ್ರ 2012",
    [AWARD_LI64]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ಕನ್ನಡ ಕಾಫಿ ಟೇಬಲ್ ಬುಕ್ 2012",
    [AWARD_LI65]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ಕಾರ್ಪೊರೇಟ್ ಜಾಹೀರಾತು 2012",
    [AWARD_LI66]: "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ಸಾಕ್ಷ್ಯಚಿತ್ರ 2012",
    [AWARD_LI67]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ಟೆಲಿವಿಷನ್ ಕಮರ್ಷಿಯಲ್ 2012",
    [AWARD_LI68]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ಸ್ ದೂರದರ್ಶನ ಸಾಕ್ಷ್ಯಚಿತ್ರ 2012",
    [AWARD_LI69]: "IIMM SCM ಅತ್ಯುತ್ತಮ ಆವಿಷ್ಕಾರ ಪ್ರಶಸ್ತಿ 2013",
    [AWARD_LI70]:
      "ಅಂತರರಾಷ್ಟ್ರೀಯ ಸಾರ್ವಜನಿಕ ಸಾರಿಗೆ ಪ್ರಶಸ್ತಿ (UITP) ನಾವೀನ್ಯತೆ ಪ್ರಶಸ್ತಿ 2013",
    [AWARD_LI71]:
      "2013 ರ ಸಾರ್ವಜನಿಕ ವಲಯದ ಬಸ್ ಫ್ಲೀಟ್ ಆಪರೇಟರ್‌ಗಾಗಿ ಅಪೊಲೊ ಸಿವಿ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI72]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಸಿಲ್ವರ್ ಅವಾರ್ಡ್ ಕಾರ್ಪೊರೇಟ್ ಜಾಹೀರಾತು 2013",
    [AWARD_LI73]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಸಿಲ್ವರ್ ಅವಾರ್ಡ್ ಸಾಕ್ಷ್ಯಚಿತ್ರ 2013",
    [AWARD_LI74]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಸಿಲ್ವರ್ ಅವಾರ್ಡ್ ಟೆಲಿವಿಷನ್ ಕಮರ್ಷಿಯಲ್ 2014",
    [AWARD_LI75]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಕಂಚಿನ ಪ್ರಶಸ್ತಿ ದೂರದರ್ಶನ ಸಾಕ್ಷ್ಯಚಿತ್ರ 2014",
    [AWARD_LI76]:
      "ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿಗೆ ಬೆಂಗಳೂರಿನ ಹಾಟ್ ಬ್ರಾಂಡ್ ಪ್ರಶಸ್ತಿ 2014 ಎಂದು ನೀಡಲಾಗಿದೆ",
    [AWARD_LI77]:
      "KSRTC 2014 ರ KSRTC ಯೊಂದಿಗೆ AC ಬಸ್ ಪ್ರಯಾಣಗಳ ವಿಭಾಗದಲ್ಲಿ ಭಾರತದ ಪ್ರತಿಷ್ಠಿತ ಭಾರತ ಸೇಸ್ ಹೌದು ಪ್ರಶಸ್ತಿಯನ್ನು ಗೆದ್ದಿದೆ",
    [AWARD_LI78]: "ITS ಮೈಸೂರು 2014 ರ ಗೋಲ್ಡನ್ ಪೀಕಾಕ್ ನವೀನ ಉತ್ಪನ್ನ/ಸೇವಾ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI79]:
      "ಗ್ಲೋಬಲ್ ಬ್ರಾಂಡ್ ಎಕ್ಸಲೆನ್ಸ್ PR ಪ್ರೊಫೆಷನಲ್ ಆಫ್ ದಿ ಇಯರ್ ಪ್ರಶಸ್ತಿ 2014",
    [AWARD_LI80]:
      "ಫ್ಲೈ ಬಸ್ ಉಪಕ್ರಮಕ್ಕಾಗಿ ಗ್ಲೋಬಲ್ ಬ್ರಾಂಡ್ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2014",
    [AWARD_LI81]: "FLYBUS ಇನಿಶಿಯೇಟಿವ್ 2014 ಗಾಗಿ SKOTCH ಅತ್ಯುತ್ತಮ 100 ಉಪಕ್ರಮಗಳು",
    [AWARD_LI82]:
      "ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯ, ಸರ್ಕಾರದಿಂದ ಶ್ರೇಷ್ಠತೆಯ ಪ್ರಶಸ್ತಿ ಮೈಸೂರು ಇಂಟೆಲಿಜೆಂಟ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಸಿಸ್ಟಮ್ ಪ್ರಾಜೆಕ್ಟ್ 2014 ಗಾಗಿ ಭಾರತದ",
    [AWARD_LI83]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಸಿಲ್ವರ್ ಅವಾರ್ಡ್ ಇನ್-ಹೌಸ್ ಮ್ಯಾಗಜೀನ್ 2015",
    [AWARD_LI84]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ಲಾಟಿನಂ ಪ್ರಶಸ್ತಿ ದೂರದರ್ಶನ ವಾಣಿಜ್ಯ 2015",
    [AWARD_LI85]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಸಿಲ್ವರ್ ಪ್ರಶಸ್ತಿ ಮುದ್ರಣ ಮಾಧ್ಯಮ ಜಾಹೀರಾತು 2015",
    [AWARD_LI86]:
      "ಸ್ವಯಂಚಾಲಿತ ಡ್ರೈವಿಂಗ್ ಟೆಸ್ಟ್ ಸಿಸ್ಟಮ್ 2015 ಗಾಗಿ CMAK ಕರ್ನಾಟಕದ ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸ ಪ್ರಶಸ್ತಿ",

    [AWARD_LI87]:
      "ಸ್ಟಾಫ್ ಡ್ಯೂಟಿ ರೋಟಾ ಸಿಸ್ಟಮ್ ಮತ್ತು ಲೀವ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ ಕಿಯೋಸ್ಕ್ ಸಿಸ್ಟಮ್ 2015 ಗಾಗಿ ASRTU ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಇನ್ನೋವೇಶನ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI88]:
      "ASRTU ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಇನ್ನೋವೇಶನ್ ಅವಾರ್ಡ್ ಫಾರ್ ಎನ್ವಿರಾನ್ಮೆಂಟ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ 2015",
    [AWARD_LI89]:
      "ಸ್ಟಾಫ್ ಡ್ಯೂಟಿ ರೋಟಾ ಸಿಸ್ಟಮ್ ಮತ್ತು ಲೀವ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ ಕಿಯೋಸ್ಕ್ ಸಿಸ್ಟಮ್ 2015 ಗಾಗಿ ಗ್ರೀನ್ಟೆಕ್ HR ಟೆಕ್ನಾಲಜಿ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್",
    [AWARD_LI90]:
      "ಮಿಲನ್ ಇಟಲಿ 2015 ರಲ್ಲಿ ಸ್ಟಾಫ್ ಡ್ಯೂಟಿ ರೋಟಾ ಸಿಸ್ಟಮ್ಗಾಗಿ UITP ಸಾರಿಗೆ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI91]: "KSRTC 2015 ರ ಬೆಂಗಳೂರು ಹಾಟ್ 50 ಬ್ರಾಂಡ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI92]:
      "ಕರ್ನಾಟಕ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ 2015 ರ ಸಪ್ಲೈ ಚೈನ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI93]:
      "ಐಟಿ ಉಪಕ್ರಮಗಳಿಗಾಗಿ ASRTU ರಾಷ್ಟ್ರೀಯ ಸಾರಿಗೆ ಶ್ರೇಷ್ಠ ಪ್ರಶಸ್ತಿ 2015",
    [AWARD_LI94]:
      "ASRTU ಉತ್ಪಾದಕತೆ ಪ್ರಶಸ್ತಿ ಕನಿಷ್ಠ ಕಾರ್ಯಾಚರಣೆ ವೆಚ್ಚ ಮೈಸೂರು ನಗರ ಸೇವೆ 2015",
    [AWARD_LI95]:
      "ಉದ್ಯೋಗಿ ಕಲ್ಯಾಣ 2015 ರಲ್ಲಿ ಎಕ್ಸಲೆನ್ಸ್ ವಿಭಾಗದಲ್ಲಿ 'ಸ್ಟಾಫ್ ಡ್ಯೂಟಿ ರೋಟಾ ಸಿಸ್ಟಮ್'ಗಾಗಿ ಇಂಡಿಯಾ ಬಸ್ ಪ್ರಶಸ್ತಿಗಳು",
    [AWARD_LI96]:
      "ಭಾರತದಲ್ಲಿ ಬಸ್ ಸಾರಿಗೆ ಸೇವೆಯಲ್ಲಿ ಶ್ರೇಷ್ಠತೆ ವಿಭಾಗದಲ್ಲಿ ಮೈಸೂರು ನಗರದ ಬುದ್ಧಿವಂತ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆ. ಇಂಡಿಯಾ ಬಸ್ ಅವಾರ್ಡ್ 2015",
    [AWARD_LI97]: "ಭಾರತದ ಹಾಟ್ ಬ್ರಾಂಡ್ ಪ್ರಶಸ್ತಿ 2015",
    [AWARD_LI98]:
      "FLYBUS ಇನಿಶಿಯೇಟಿವ್ 2015 ಗಾಗಿ SKOTCH ದೇಶದ ಅತ್ಯುತ್ತಮ 100 ಉಪಕ್ರಮಗಳು",
    [AWARD_LI99]:
      "ಸಣ್ಣ ಮತ್ತು ಮಧ್ಯಮ ಪಟ್ಟಣಗಳು ಮತ್ತು ನಗರಗಳಲ್ಲಿ ಸಂಘಟಿತ ಸಿಟಿ ಬಸ್ ಸೇವೆಗಳಿಗಾಗಿ ದೇಶದ ಅತ್ಯುತ್ತಮ 100 ಉಪಕ್ರಮಗಳು - 2015",
    [AWARD_LI100]:
      "ಸ್ಟಾಫ್ ಡ್ಯೂಟಿ ರೋಟಾ ಸಿಸ್ಟಮ್ 2015 ಗಾಗಿ ಸ್ಕಾಚ್ ದೇಶದ ಅತ್ಯುತ್ತಮ 100 ಉಪಕ್ರಮಗಳು",
    [AWARD_LI101]:
      "SKOCH ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ರಶಸ್ತಿ ಸಣ್ಣ ಮತ್ತು ಮಧ್ಯಮ ಪಟ್ಟಣಗಳು ಮತ್ತು ನಗರಗಳಿಗೆ ಸಾರ್ವಜನಿಕ ಸಾರಿಗೆ ನಗರ ಬಸ್ 2015",
    [AWARD_LI102]:
      "ಮೈಸೂರು ನಗರದಲ್ಲಿ 2015 ರಲ್ಲಿ ಬುದ್ಧಿವಂತ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಗಾಗಿ 2 ನೇ ವಾರ್ಷಿಕ PSU ಪ್ರಶಸ್ತಿ",
    [AWARD_LI103]:
      "ಭಾರತ 2015ರ ನಗರಾಭಿವೃದ್ಧಿ ಸಚಿವಾಲಯ, ಸರ್ಕಾರದಿಂದ ಶ್ರೇಷ್ಠತೆಯ ಪ್ರಶಸ್ತಿ ಸಣ್ಣ ಮತ್ತು ಮಧ್ಯಮ ಪಟ್ಟಣಗಳು ಮತ್ತು ನಗರಗಳಿಗೆ ಸಂಘಟಿತ ಸಿಟಿ ಬಸ್ ಸೇವೆಗಳನ್ನು ಒದಗಿಸುವ ಉಪಕ್ರಮಕ್ಕಾಗಿ ಸತತವಾಗಿ 6 ನೇ ಬಾರಿಗೆ ",
    [AWARD_LI104]: "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಅವಾರ್ಡ್ ಇನ್-ಹೌಸ್ ಮ್ಯಾಗಜೀನ್ 2016",
    [AWARD_LI105]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ-ಕಾರ್ಪೊರೇಟ್ ಜಾಹೀರಾತು 2016",
    [AWARD_LI106]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ-ಸಾಕ್ಷ್ಯಚಿತ್ರ ಚಲನಚಿತ್ರ ಆನ್ ಬಯೋ ಬಸ್ 2016",
    [AWARD_LI107]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿಗಳು- ಬಯೋ ಬಸ್ 2016 ರ ಕರಪತ್ರ",
    [AWARD_LI108]:
      "PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ-ಬ್ರಾಂಡಿಂಗ್ ಆಫ್ ಐರಾವತ್ ಡೈಮಂಡ್ ಕ್ಲಾಸ್ ಬಸ್ 2016",
    [AWARD_LI109]:
      "ಚಾಣಕ್ಯ ಪ್ರಶಸ್ತಿ ಅತ್ಯುತ್ತಮ PR ಮತ್ತು ವರ್ಷದ ಕಾರ್ಪೊರೇಟ್ ಸಂವಹನ ವ್ಯಕ್ತಿ ಪ್ರಶಸ್ತಿ 2016",
    [AWARD_LI110]:
      "ಗ್ಲೋಬಲ್ ಕಮ್ಯುನಿಕೇಷನ್ ಅಸೋಸಿಯೇಷನ್ ಅವಾರ್ಡ್ ಫಾರ್ ಎಕ್ಸಲೆನ್ಸ್ ಇನ್ ಕಮ್ಯುನಿಕೇಷನ್ ಇನ್ ಸರ್ಕಾರಿ ವಲಯ 2016",
    [AWARD_LI111]: "NIB ರಾಷ್ಟ್ರೀಯ ಪ್ರಶಸ್ತಿ-2016 ಇನ್-ಹೌಸ್ ಮ್ಯಾಗಜೀನ್ 2016",
    [AWARD_LI112]: "ಕರ್ನಾಟಕದ ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸ ಪ್ರಶಸ್ತಿ (CMAK) 2016",
    [AWARD_LI113]: "AWATAR 2016 ಗಾಗಿ ಡಿಜಿಟಲ್ ಸಬಲೀಕರಣ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI114]:
      "ಪರಿಸರ ನಿರ್ವಹಣೆಗಾಗಿ ASRTU ವಾರ್ಷಿಕ ವಿಶೇಷ ಪ್ರಶಸ್ತಿಗಳು ಪ್ರಕೃತಿ 2016",
    [AWARD_LI115]:
      "ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಸಾರಿಗೆ 2016 ರ ವಿಭಾಗದಲ್ಲಿ ಇಂಡಿಯಾ ಪ್ರೈಡ್ ಪ್ರಶಸ್ತಿ 'ದೇಶದ ಅತ್ಯುತ್ತಮ ರಾಜ್ಯ PSU'",
    [AWARD_LI116]:
      "ವರ್ಲ್ಡ್ ರಿಸೋರ್ಸ್ ಇನ್‌ಸ್ಟಿಟ್ಯೂಟ್ ಕನೆಕ್ಟ್‌ಕಾರೊ ಪ್ರಶಸ್ತಿ ಎರಡು ಮತ್ತು ಮೂರು ನಗರಗಳು ಮತ್ತು ಪಟ್ಟಣಗಳಲ್ಲಿ ಸಂಘಟಿತ ಸಿಟಿ ಬಸ್ ಸೇವೆಗಳಿಗಾಗಿ 2016",
    [AWARD_LI117]: "ನೇಮಕಾತಿ 2016 ರಲ್ಲಿ ನಾವೀನ್ಯತೆಗಾಗಿ ಗ್ರೀನ್ಟೆಕ್ HR ಪ್ರಶಸ್ತಿ",
    [AWARD_LI118]:
      "ಸ್ಮಾರ್ಟ್ ಅರ್ಬನ್ ಮೊಬಿಲಿಟಿ ITS ಮೈಸೂರು 2016 ಗಾಗಿ 2 ನೇ ಸ್ಮಾರ್ಟ್ ಸಿಟೀಸ್ ಇಂಡಿಯಾ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI119]:
      "ಎಕನಾಮಿಕ್ ಟೈಮ್ಸ್ ಸಪ್ಲೈ ಚೈನ್ & ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಅವಾರ್ಡ್ಸ್-2016 2016",
    [AWARD_LI120]: "FKCCI ಕರ್ನಾಟಕ ಪ್ರವಾಸೋದ್ಯಮ ಪ್ರಶಸ್ತಿ-2016 2016",
    [AWARD_LI121]: "ಗ್ರೀನ್ಟೆಕ್ ಸೇಫ್ಟಿ ಅವಾರ್ಡ್-2016 2016",
    [AWARD_LI122]: "ಇಂಡಿಯಾ ಬಸ್ ಅವಾರ್ಡ್ಸ್-2016 2016",
    [AWARD_LI123]: "ಎಲೆಟ್ಸ್ ಸ್ಮಾರ್ಟ್ ಸಿಟಿ ಪ್ರಶಸ್ತಿ-2016 2016",
    [AWARD_LI124]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ -2016 ಪ್ರಕೃತಿ (ಗ್ರೀನ್ ಸ್ಕ್ವಾಡ್) ಮತ್ತು ಬಯೋ-ಬಸ್ (ಗೋ-ಗ್ರೀನ್-ಥಿಂಕ್ ಗ್ರೀನ್) 2016",
    [AWARD_LI125]:
      "ಸ್ಕೋಚ್ ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ -2016 ಅವತಾರ್ ಎನಿ ವೇರ್ ಎನಿ ಟೈಮ್ ಅಡ್ವಾನ್ಸ್ ರಿಸರ್ವೇಶನ್ ಸಿಸ್ಟಮ್ 2016",
    [AWARD_LI126]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ -2016 ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್ 2016 ಜೊತೆಗೆ ಬುದ್ಧಿವಂತ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಗಳು",
    [AWARD_LI127]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ -2016 ವೆಹಿಕಲ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಮಾನಿಟರಿಂಗ್ ಸಿಸ್ಟಮ್ ಮತ್ತು ಪ್ಯಾಸೆಂಜರ್ ಮಾಹಿತಿ ವ್ಯವಸ್ಥೆ - VTMS & PIS ಪ್ರಾಜೆಕ್ಟ್ 2016",

    [AWARD_LI128]:
      "CMO ASIA ಸ್ಮಾರ್ಟ್ ಸಿಟಿ ಪ್ರಶಸ್ತಿ-2016 ಸಿಂಗಾಪುರ- ಸ್ಮಾರ್ಟ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಇನಿಶಿಯೇಟಿವ್ 2016",
    [AWARD_LI129]:
      "CMO ASIA ಸ್ಮಾರ್ಟ್ ಸಿಟಿ ಪ್ರಶಸ್ತಿ-2016 ಸಿಂಗಾಪುರ- ಅತ್ಯುತ್ತಮ ಇನ್ನೋವೇಶನ್ ಇನಿಶಿಯೇಟಿವ್ 2016",
    [AWARD_LI130]:
      "CMO ASIA ಸ್ಮಾರ್ಟ್ ಸಿಟಿ ಪ್ರಶಸ್ತಿ-2016 ಸಿಂಗಾಪುರ- ಸ್ಮಾರ್ಟ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಇನಿಶಿಯೇಟಿವ್ 2016",
    [AWARD_LI131]: "ವಿಶ್ವ ಆರೋಗ್ಯ ಚಿನ್ನದ ಪ್ರಶಸ್ತಿ-2016 2016",
    [AWARD_LI132]:
      "HR 2016 ರಲ್ಲಿ ಐಡಿಯಾಸ್ ಮತ್ತು ಇನ್ನೋವೇಶನ್ಸ್ಗಾಗಿ ಏಷ್ಯಾ ಪೆಸಿಫಿಕ್ HR ಪ್ರಶಸ್ತಿ",
    [AWARD_LI133]:
      "ಅದರ ಮೈ ಬಸ್ 2016 ಗಾಗಿ ಕಾರ್ಪೊರೇಟ್ ಸಂವಹನದಲ್ಲಿ ಶ್ರೇಷ್ಠತೆಗಾಗಿ ರಾಷ್ಟ್ರೀಯ ಪ್ರಶಸ್ತಿಗಳು",
    [AWARD_LI134]:
      "SKOCH ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ಲಾಟಿನಂ ಪ್ರಶಸ್ತಿ -2016 ಪ್ರಕೃತಿ (ಗ್ರೀನ್ ಸ್ಕ್ವಾಡ್) ಮತ್ತು ಬಯೋ-ಬಸ್ (ಗೋ-ಗ್ರೀನ್-ಥಿಂಕ್ ಗ್ರೀನ್) 2016",
    [AWARD_LI135]:
      "ಸ್ಕೋಚ್ ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ಲಾಟಿನಂ ಪ್ರಶಸ್ತಿ -2016 ಅವತಾರ್ ಎನಿ ವೇರ್ ಎನಿ ಟೈಮ್ ಅಡ್ವಾನ್ಸ್ ರಿಸರ್ವೇಶನ್ ಸಿಸ್ಟಮ್ 2016",
    [AWARD_LI136]:
      "SKOCH ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ಲಾಟಿನಮ್ ಪ್ರಶಸ್ತಿ -2016 ಮೊಬೈಲ್ ಆಪ್ 2016 ಜೊತೆಗೆ ಬುದ್ಧಿವಂತ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಗಳು",
    [AWARD_LI137]:
      "10ನೇ ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಮತ್ತು ಸಪ್ಲೈ ಚೈನ್ ಲೀಡರ್‌ಶಿಪ್ ಅವಾರ್ಡ್‌ಗಳು-ಗ್ರಾಹಕರ ಅನ್ಯೋನ್ಯತೆ @ ಸರ್ವಿಸ್ ಎಕ್ಸಲೆನ್ಸ್ ಕಂಪನಿ ಆಫ್ ದಿ ಇಯರ್ 2016",
    [AWARD_LI138]:
      "ಡ್ರೈವರ್ಸ್ ಆಫ್ ಡಿಜಿಟಲ್ ಪ್ರಶಸ್ತಿ - ಅತ್ಯುತ್ತಮ ವೆಬ್‌ಸೈಟ್ - ಟ್ರಾವೆಲ್ 2016",
    [AWARD_LI139]: "ಗ್ರೀನ್‌ಟೆಕ್ ಪರಿಸರ ಪ್ರಶಸ್ತಿ 2016",
    [AWARD_LI140]: "ಗ್ಲೋಬಲ್ ಮಾರ್ಕೆಟಿಂಗ್ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2016",
    [AWARD_LI141]:
      "ಮೊಬೈಲ್ ಆಪ್ 2016 ನೊಂದಿಗೆ SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಇಂಟೆಲಿಜೆಂಟ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಸಿಸ್ಟಮ್ (ITS)",
    [AWARD_LI142]: "ಸ್ಕೋಚ್ ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಇಟ್ಸ್ ಮೈ ಬಸ್ 2016",
    [AWARD_LI143]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಬ್ರ್ಯಾಂಡಿಂಗ್ ಇನಿಶಿಯೇಟಿವ್ಸ್ ಫಾರ್ ಸರ್ವೀಸ್ ಎಕ್ಸಲೆನ್ಸ್ 2016",
    [AWARD_LI144]:
      "ಆರೋಗ್ಯಕರ ಕೆಲಸದ ಸ್ಥಳಕ್ಕಾಗಿ ಸ್ಕೋಚ್ ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಇನಿಶಿಯೇಟಿವ್ಸ್ 2016",
    [AWARD_LI145]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಇನಿಶಿಯೇಟಿವ್ಸ್ ಫಾರ್ ಸುಧಾರಿತ ರಸ್ತೆ ಸುರಕ್ಷತೆ 2016",
    [AWARD_LI146]:
      "ಸ್ಕೋಚ್ ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಅವತಾರ್ (ಎನಿ ಟೈಮ್ ಎನಿ ವೇರ್ ಅಡ್ವಾನ್ಸ್ ರಿಸರ್ವೇಶನ್ ಸಿಸ್ಟಮ್) 2016",
    [AWARD_LI148]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಇನಿಶಿಯೇಟಿವ್ಸ್ ಸಿಟಿ ಬಸ್ ಸೇವೆ ಮಧ್ಯಮ ಮತ್ತು ಸಣ್ಣ ನಗರಗಳಿಗೆ 2016",
    [AWARD_LI149]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಸ್ವಯಂಚಾಲಿತ ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಡ್ರೈವಿಂಗ್ ಟೆಸ್ಟ್ ಸಿಸ್ಟಮ್ 2016",
    [AWARD_LI150]: "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಫ್ಲೈ ಬಸ್ 2016",
    [AWARD_LI151]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಸ್ಟಾಫ್ ಡ್ಯೂಟಿ ರೋಟಾ ಮತ್ತು ಲೀವ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ ಕಿಯೋಸ್ಕ್ ಸಿಸ್ಟಮ್ 2016",
    [AWARD_LI152]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಸ್ಮಾರ್ಟ್ ಟೆಕ್ನಾಲಜಿ ಇನ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಆಪರೇಷನ್ಸ್ 2016",
    [AWARD_LI153]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಕ್ಲೀನ್ಲಿನೆಸ್ ಉಪಕ್ರಮಗಳು ಕೆಲಸದ ಸ್ಥಳದಲ್ಲಿ 2016",
    [AWARD_LI154]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ವೆಹಿಕಲ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಮಾನಿಟರಿಂಗ್ ಸಿಸ್ಟಮ್ ಮತ್ತು ಪ್ಯಾಸೆಂಜರ್ ಇನ್ಫರ್ಮೇಷನ್ ಸಿಸ್ಟಮ್ - VTMS & PIS ಪ್ರಾಜೆಕ್ಟ್. 2016",
    [AWARD_LI155]:
      "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ WAPPA - ಕಾರ್ಯಸ್ಥಳದ ಮದ್ಯಪಾನ ತಡೆಗಟ್ಟುವ ಕಾರ್ಯಕ್ರಮ ಮತ್ತು ಚಟುವಟಿಕೆ 2016",
    [AWARD_LI156]: "SKOCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್ ಪ್ರಕೃತಿ & ಬಯೋ ಬಸ್ 2016",
    [AWARD_LI157]: "ವಿಶ್ವ ನಾಯಕತ್ವ ಪ್ರಶಸ್ತಿ- ITS 2016",
    [AWARD_LI158]: "BW ಬಿಸಿನೆಸ್ ವರ್ಲ್ಡ್ ಅವಾರ್ಡ್ 2016",
    [AWARD_LI159]: "ಪ್ರಭಾವಿ ವ್ಯಾಪಾರ ಪ್ರಶಸ್ತಿ 2016",
    [AWARD_LI160]:
      "ದಿ ಇಂಡಿಯಾ PR& ಕಾರ್ಪೊರೇಟ್ ಕಮ್ಯುನಿಕೇಷನ್ಸ್ ಅವಾರ್ಡ್-ಪ್ರಕೃತಿ 2016",
    [AWARD_LI161]:
      "ಇಂಡಿಯಾ PR & ಕಾರ್ಪೊರೇಟ್ ಕಮ್ಯುನಿಕೇಷನ್ಸ್ ಅವಾರ್ಡ್-ಇದು ನನ್ನ ಬಸ್ 2016",
    [AWARD_LI162]: "SKOCH ಮೊಬಿಲಿಟಿ ಅವಾರ್ಡ್ WAPPA 2016",
    [AWARD_LI163]: "ಮೊಬೈಲ್ ಆಪ್ 2016 ನೊಂದಿಗೆ SKOCH ಮೊಬಿಲಿಟಿ ಪ್ರಶಸ್ತಿ ITS",
    [AWARD_LI164]: "SKOCH ಮೊಬಿಲಿಟಿ ಅವಾರ್ಡ್ ಸಿಟಿ ಬಸ್ ಸೇವೆಗಳು 2016",
    [AWARD_LI165]: "SKOCH ಮೊಬಿಲಿಟಿ ಅವಾರ್ಡ್ ಪ್ರಕೃತಿ ಮತ್ತು ಬಯೋ ಬಸ್ 2016",
    [AWARD_LI166]: "SKOCH ಮೊಬಿಲಿಟಿ ಪ್ರಶಸ್ತಿ ಆರೋಗ್ಯಕರ ಕಾರ್ಯಸ್ಥಳ 2016",
    [AWARD_LI167]: "ರಾಷ್ಟ್ರೀಯ ಇ-ಆಡಳಿತ ಚಿನ್ನದ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI168]: "ಲಿಮ್ಕಾ ಬುಕ್ ಆಫ್ ರೆಕಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI169]: "ಗ್ಲೋಬಲ್ ಕ್ಲೀನ್ ಇಂಡಿಯಾ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI170]: "ಗ್ಲೋಬಲ್ ಸೇಫ್ಟಿ ಇಂಡಿಯಾ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI171]: "ಮಂಥನ್ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI172]: "CMAK ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI173]: "PSU ನಾಯಕತ್ವ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI174]: "PSU ಪ್ರಶಸ್ತಿ- ಅವತಾರ್ 2017",
    [AWARD_LI175]: "EKDKN 2017 ರ HR ಪ್ರಶಸ್ತಿಗಳನ್ನು ಮೀರಿದೆ",
    [AWARD_LI176]: "EKDKN ಎಕ್ಸೀಡ್ ಎನ್ವಿರಾನ್ಮೆಂಟ್ ಅವಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI177]: "BBC ಉದ್ಯೋಗದಾತ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI178]: "PRCI ಕಾರ್ಪೊರೇಟ್ ನಾಯಕತ್ವ ಪ್ರಶಸ್ತಿ- ಚಾಣಕ್ಯ 2017",
    [AWARD_LI179]: "NIB ಪ್ರಶಸ್ತಿಗಳು-ಇನ್ ಹೌಸ್ ಮ್ಯಾಗಜೀನ್ 2017",
    [AWARD_LI180]: "NIB ಪ್ರಶಸ್ತಿಗಳು- ಇದು ನನ್ನ ಬಸ್ ಚಲನಚಿತ್ರ 2017",
    [AWARD_LI181]: "NIB ಪ್ರಶಸ್ತಿಗಳು- ಬ್ರೌಚರ್ 2017",
    [AWARD_LI182]: "ಇಂಡಿಯನ್ ಬ್ರಾಂಡ್ ಕನ್ವೆನ್ಷನ್ ಅವಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI183]: "ಇಂಡಿಯನ್ ಬ್ರಾಂಡ್ ಕನ್ವೆನ್ಷನ್ ಅವಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI184]: "ಇಂಡಿಯನ್ ಬ್ರಾಂಡ್ ಕನ್ವೆನ್ಷನ್ ಅವಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI185]: "ಇಂಡಿಯನ್ ಬ್ರಾಂಡ್ ಕನ್ವೆನ್ಷನ್ ಅವಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI186]:
      "ಇ-ಆಡಳಿತ 2017 ರಲ್ಲಿ ತಂತ್ರಜ್ಞಾನಕ್ಕಾಗಿ BPCL ಇನ್ನೋವೇಶನ್ ಪ್ರಶಸ್ತಿ",
    [AWARD_LI187]: "PRCI ಪ್ರಶಸ್ತಿಗಳು- ಇದು ನನ್ನ ಬಸ್ ಅಭಿಯಾನ 2017",
    [AWARD_LI189]: "PRCI ಪ್ರಶಸ್ತಿಗಳು- ವಾರ್ಷಿಕ ವರದಿ 2017",
    [AWARD_LI190]: "PRCI ಪ್ರಶಸ್ತಿಗಳು- ಇನ್-ಹೌಸ್ ಮ್ಯಾಗಜೀನ್ 2017",
    [AWARD_LI191]: "PRCI ಪ್ರಶಸ್ತಿಗಳು-ಕಾರ್ಪೊರೇಟ್ ಜಾಹೀರಾತು- ಮುದ್ರಣ 2017",
    [AWARD_LI192]: "PRCI ಪ್ರಶಸ್ತಿಗಳು- ಚಲನಚಿತ್ರ 2017",
    [AWARD_LI193]: "ASRTU ಪ್ರಶಸ್ತಿ-ಪ್ರಾಫಿಟ್ ಮೇಕಿಂಗ್ STU 2016-17 2017",
    [AWARD_LI194]: "ಇಂಡಿಯಾ ಪ್ರೈಡ್ ಅವಾರ್ಡ್ 2017",
    [AWARD_LI195]: "ಕರೋ ಅವಾರ್ಡ್ಸ್ 2017 ಅನ್ನು ಸಂಪರ್ಕಿಸಿ",
    [AWARD_LI196]: "UITP ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI197]: "ಹುಡ್ಕೊ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI198]: "ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಸಬಲೀಕರಣ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI199]: "M3 ಮಾರ್ಕೆಟಿಂಗ್ ಪ್ರಶಸ್ತಿಗಳು 2017",

    [AWARD_LI200]: "ಗ್ರೀನ್‌ಟೆಕ್ ಮಾನವ ಸಂಪನ್ಮೂಲ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI201]: "ಇಂಡಿಯಾ ಬಸ್ ಅವಾರ್ಡ್ಸ್-ಪರಿಸರ 2017",
    [AWARD_LI202]: "ಇಂಡಿಯಾ ಬಸ್ ಅವಾರ್ಡ್ಸ್- ಅತ್ಯುತ್ತಮ ಸಾರಿಗೆ ಸೇವೆ ITS 2017",
    [AWARD_LI203]: "ಪ್ರಾಜೆಕ್ಟ್ ಮ್ಯಾನೇಜರ್ಸ್ ಇನ್ಸ್ಟಿಟ್ಯೂಟ್ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI204]: "ವರ್ಲ್ಡ್ ವೈಡ್ ಅಚೀವರ್ಸ್ ಬಿಸಿನೆಸ್ ಅವಾರ್ಡ್ಸ್ 2017",
    [AWARD_LI205]: "ಪ್ರವಾಸ್ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2017",
    [AWARD_LI206]: "ಪ್ರವಾಸ್ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2017",
    [AWARD_LI207]: "ಪ್ರವಾಸ್ ಎಕ್ಸಲೆನ್ಸ್ ಅವಾರ್ಡ್ 2017",
    [AWARD_LI208]: "ASRTU ರಾಷ್ಟ್ರೀಯ ಸಾರಿಗೆ ಶ್ರೇಷ್ಠ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI209]: "SKOTCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್- ಪ್ರಕೃತಿ 2017",
    [AWARD_LI210]: "SKOTCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್- VTMS 2017",
    [AWARD_LI211]: "ಸ್ಕಾಚ್ ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್- ಅದರ 2017",
    [AWARD_LI212]: "SKOTCH ಆರ್ಡರ್ ಆಫ್ ಮೆರಿಟ್- ಸಿಟಿ ಬಸ್ ಸೇವೆಗಳು 2017",
    [AWARD_LI213]: "IRU ಪ್ರಶಸ್ತಿಗಳು-2017 2017",
    [AWARD_LI214]: "ಬಿಸಿನೆಸ್ ವರ್ಲ್ಡ್ ಸ್ಮಾರ್ಟ್ ಸಿಟಿ ಪ್ರಶಸ್ತಿ 2017",
    [AWARD_LI215]: "CMAK ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸ ಪ್ರಶಸ್ತಿ 2018",
    [AWARD_LI216]: "PRCI ಚಾಣಕ್ಯ ಪ್ರಶಸ್ತಿ ಕಾರ್ಪೊರೇಟ್ ಐಡಿಯಾ ಆಫ್ ದಿ ಇಯರ್ 2018",
    [AWARD_LI217]: "ಸರಿಗೆ ಸಂಪದ- PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ 2018",
    [AWARD_LI218]: "ರೇಡಿಯೋ ಜಿಂಗಲ್- PRCI ಕಾರ್ಪೊರೇಟ್ ಕೊಲ್ಯಾಟರಲ್ ಪ್ರಶಸ್ತಿ 2018",
    [AWARD_LI219]: "ಇಂಡಿಯಾ ಪ್ರೈಡ್ ಅವಾರ್ಡ್ 2018",
    [AWARD_LI220]: "ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ರಶಸ್ತಿ- VTMS 2018",
    [AWARD_LI221]: "ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ರಶಸ್ತಿ- ಅವತಾರ್ 2018",
    [AWARD_LI222]:
      "ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ರಶಸ್ತಿ- ಆರೋಗ್ಯಕರ ಕಾರ್ಯಸ್ಥಳದ ಉಪಕ್ರಮಗಳು 2018",
    [AWARD_LI223]:
      "ಸ್ಮಾರ್ಟ್ ಗವರ್ನೆನ್ಸ್ ಪ್ರಶಸ್ತಿ- 2018 ರ ಕಾರ್ಯಾಚರಣೆಗಳಲ್ಲಿ ಸ್ಮಾರ್ಟ್ ತಂತ್ರಜ್ಞಾನ",
    [AWARD_LI224]: "ಇಂಡಿಯಾ ಬಸ್ ಅವಾರ್ಡ್ 2018",
    [AWARD_LI225]: "ರಾಜ್ಯ ಇ-ಆಡಳಿತ ಪ್ರಶಸ್ತಿ 2018",
    [AWARD_LI226]: "ಶ್ರೇಷ್ಠತೆಯ ಪ್ರಶಸ್ತಿ -MoUD 2018",
    [AWARD_LI227]: "ಸ್ಕೋಚ್ ಪ್ರಶಸ್ತಿ-ಬೆಳ್ಳಿ 2019",
    [AWARD_LI228]: "SKOCH ಪ್ರಶಸ್ತಿ-ತಾಮ್ರ 2019",
    [AWARD_LI229]: "SKOCH ಮೊಬಿಲಿಟಿ ಪ್ರಶಸ್ತಿ-ಬೆಳ್ಳಿ 2019",
    [AWARD_LI230]: "PRCI- ಆಂತರಿಕ ಪತ್ರಿಕೆ- ಬೆಳ್ಳಿ 2019",
    [AWARD_LI231]: "PRCI_ ಜಾಗೃತಿ ವೀಡಿಯೊ-ಬೆಳ್ಳಿ 2019",
    [AWARD_LI232]: "PRCI- ಕಾರ್ಪೊರೇಟ್ ವೀಡಿಯೊ-Slver 2019",
    [AWARD_LI233]: "CMAK ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸ ಪ್ರಶಸ್ತಿ 2019",
    [AWARD_LI234]: "ಲಾಭ ಗಳಿಸುವ STU -ASRTU ಉತ್ಪಾದಕತೆ ಪ್ರಶಸ್ತಿ 2019",
    [AWARD_LI235]: "ಕನಿಷ್ಠ ಕಾರ್ಯಾಚರಣೆ ವೆಚ್ಚ ಮೈಸೂರು ನಗರ -ASRTU 2019",
    [AWARD_LI236]: "ಹುಡ್ಕೊ ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸಗಳ ಪ್ರಶಸ್ತಿ 2019",
    [AWARD_LI237]:
      "IOL ಟೈಮ್ಸ್ ನೌ ಬೆಸ್ಟ್ ಪ್ಯಾಸೆಂಜರ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್-ಇಂಟರ್ ಸಿಟಿ 2019",
    [AWARD_LI238]: "IOL ಟೈಮ್ಸ್ ನೌ ವುಮೆನ್ ಅಚೀವರ್ ಅವಾರ್ಡ್ 2019",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
